import intl from 'react-intl-universal';
import { getCdrIbDetails } from '@/api/softPhone';
import { Modal } from '@/components';
import { Input, Space, message } from 'antd';
import { useState } from 'react';
import { history } from '@umijs/max';
import style from '../index.less';

const Logout: React.FC = () => {
    const [show, setShow] = useState(false);
    const [value, setValue] = useState<string>();

    const onOpenPage = () => {
        if (!value) {
            message.warning(intl.get('请输入通话ID'));
            return;
        }
        return getCdrIbDetails(value).then((res) => {
            if (res.data.callType === intl.get('呼入')) {
                setShow(false);
                setValue('');
                history.push(`/online/${res.data.customerNumber}/${value}`);
            } else {
                message.warning(intl.get('只能打开呼入通话弹屏'));
            }
        });
    };

    return (
        <>
            <span
                className={style.headerBtn}
                onClick={() => setShow(true)}
            >
                {intl.get('重新打开来电弹屏')}
            </span>

            <Modal
                open={show}
                title={intl.get('重新打开来电弹屏')}
                onCancel={() => {
                    setValue('');
                    setShow(false);
                }}
                onOk={onOpenPage}
            >
                <Space style={{ padding: '20px 0' }}>
                    <span style={{ color: 'red' }}>*</span>
                    {intl.get('通话ID:')}
                    <Input
                        style={{ width: 400 }}
                        value={value}
                        maxLength={200}
                        placeholder={intl.get('请输入通话ID')}
                        onChange={(e) => setValue(e.target.value)}
                    />
                </Space>
            </Modal>
        </>
    );
};

export default Logout;
